import { render, staticRenderFns } from "./TopButton.vue?vue&type=template&id=70ba9ad8&scoped=true"
import script from "./TopButton.ts?vue&type=script&lang=ts&external"
export * from "./TopButton.ts?vue&type=script&lang=ts&external"
import style0 from "./TopButton.vue?vue&type=style&index=0&id=70ba9ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba9ad8",
  null
  
)

export default component.exports